import React from 'react';
export default function times(props) {
  return (
<svg xmlns="http://www.w3.org/2000/svg" style={props.style} viewBox="0 0 46.874 46.876">
  <path d="M30.41-28.125,46.189-43.9a2.34,2.34,0,0,0,0-3.308l-3.667-3.667a2.34,2.34,0,0,0-3.308,0L23.437-35.1,7.658-50.877a2.34,2.34,0,0,0-3.308,0L.685-47.212a2.34,2.34,0,0,0,0,3.308L16.465-28.125.685-12.346a2.34,2.34,0,0,0,0,3.308L4.352-5.372a2.34,2.34,0,0,0,3.308,0L23.437-21.152,39.217-5.373a2.34,2.34,0,0,0,3.308,0L46.191-9.04a2.34,2.34,0,0,0,0-3.308Z" transform="translate(-0.001 51.563)"/>
</svg>)
}